import { render, staticRenderFns } from "./AboutExportA.vue?vue&type=template&id=70bd51af"
import script from "./AboutExportA.vue?vue&type=script&lang=js"
export * from "./AboutExportA.vue?vue&type=script&lang=js"
import style0 from "./AboutExportA.vue?vue&type=style&index=0&id=70bd51af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports